<template>
  <login v-if="!getIsLogin() && !getIsQrCode() && !getIsVantiQrCode() && !getIsCompleteRegistration()"></login>
  <qr-code v-else-if="!getIsLogin() && getIsQrCode() && !getIsCompleteRegistration()"></qr-code>
  <vanti-qr-code v-else-if="!getIsLogin() && getIsVantiQrCode() && !getIsCompleteRegistration()"></vanti-qr-code>
  <article v-else>
    <capacity-view v-if="getCapacityValidator()"></capacity-view>
    <v-app id="inspire" v-else>
      <alert-modal v-if="getIsInAlert()"></alert-modal>
      <loader v-if="getLoader()"></loader>
      <new-navigation ref="navigationDrawer" v-if="!getIsCompleteRegistration() && getCompanyLoaded()"></new-navigation>
      <v-content style="background: #F7F7F9;">
        <v-container
          fluid
          fill-height
          :class="
            !$refs.navigationDrawer
              ? 'general_contain'
              : $refs.navigationDrawer.drawer === false
              ? 'general_contain_collapse'
              : 'general_contain'
          "
        >
          <v-layout justify-center>
            <v-flex x12>
              <v-flex x12>
                <router-view />
              </v-flex>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </v-app>
  </article>
</template>

<script>
import CodeQr from "@/components/views/invitations/CodeQr.vue";
import VantiCodeQr from "@/components/views/invitations/VantiCodeQr.vue";
import { watch } from "vue";
import { useRoute } from "vue-router";

  export default {
    name: 'App',
    data: () => ({
    }),
    props: {
      source: String
    },
    components: {
      'qr-code': CodeQr,
      'vanti-qr-code': VantiCodeQr,
    },
    mounted(){
      if(navigator.userAgent=="Comfamiliar-Gimnasios-Desktop-App"){
        document.addEventListener("keydown", function(e) {
          e = e || window.event;
          if (e.ctrlKey) {
            var c = e.which || e.keyCode;
            if (c == 82) {
              e.preventDefault();
              e.stopPropagation();
            }
          }
        })
      }
      var uuid
      if(localStorage.device_id != undefined &&
         localStorage.device_id != null &&
         localStorage.device_id != ''){
        uuid = localStorage.device_id
      } else {
        uuid = this.$uuid.v1()
        localStorage.device_id = uuid
      }
      this.updateIsLogin(false);
      this.updateCapacityValidator(false);
      this.updateDeviceId(uuid);
      this.updateTags([])
      this.findCategories()
      this.findTags()
      this.findLocations()
      try{
        let vm = this;
        let params = this.$router.app._route.query
        if(JSON.stringify(params)!=='{}' && (params.email!==undefined && params.email!=='') && (params.password!==undefined && params.password!=='') && (params.company_id!==undefined && params.company_id!=='')){
          this.validateUserCredentials(params.email, params.password, params.company_id)
          this.updateIsCompleteRegistration(true);
        }else if (JSON.stringify(params)!=='{}' &&
         //(params.user_id!==undefined && params.user_id!=='') &&
         (params.device_id!==undefined && params.device_id!=='') &&
         (params.invited_client_id!==undefined && params.invited_client_id!=='')) {
          this.updateIsQrCode(true);
        }else if (JSON.stringify(params)!=='{}' &&
         (params.sublocation_id!==undefined && params.sublocation_id!=='') &&
         (params.booking_id!==undefined && params.booking_id!=='')) {
          this.updateIsVantiQrCode(true);
        }
      }catch(e){
        console.log('CodeQr not params ', e);
      }

      // this.$watch( ()=> this.$route.path,(to, from)=> {
      //   console.log('route path has changed from ' +from+' to '+to )
      // })
    }
  }
</script>

<style lang="scss">
@import "./assets/stylesheets/application.scss";
#keep main .container {
  height: 660px !important;
}
.general_contain {
  padding-right: 4.1% !important; //4.8
  padding-top: 100px !important;
  padding-left: 8.2% !important;
  padding-bottom: 2.3% !important;
  //padding-left: 9.6%;
  // @include breakpoint(big-desktop-up) {
  //   padding-left: 12.3% !important;
  // }
}
.general_contain_collapse {
  padding-right: 4.1% !important; //4.8
  padding-top: 100px !important;
  padding-left: 4.1% !important;
  padding-bottom: 2.3% !important;
  //padding-left: 9.6%;
  @include breakpoint(big-desktop-up) {
    //padding-left: 12.5%;
    padding-left: 4.1% !important;
  }
}
.v-navigation-drawer__border {
  display: none !important;
}
.text {
  font-weight: 400 !important;
}
.float_card {
  margin-left: 30px !important;
  width: 35% !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  max-height: 80vh !important;
}
.divider {
  margin: 40px auto !important;
}
.application {
  font-family: "Poppins" !important;
  color: #99a3b5 !important;
}
.primary--text {
  color: #1476fb !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue